<template>
     <div class="container-fluid  pt-2">

  <div class="row">
    <!-- Customer Info -->
    <div class="col-md-4 col-12">
      <div class="card">
        <div class="card-body text-center">
          <h4 class="text-primary font-weight-bold">{{ customer_data.full_name }}</h4>
          <ul class="text-left">
            <li><strong>Date Added:</strong> {{ formatDate(customer_data.created_at, 'DD-MMM-YYYY') }}</li>
            <li v-if="customer_data.phone"><strong>Phone:</strong> {{ customer_data.phone }}</li>
            <li v-if="customer_data.email"><strong>Email:</strong> {{ customer_data.email }}</li>
            <li v-if="customer_data.apartment"><strong>Address:</strong> {{ customer_data.apartment }} {{ customer_data.address_address }}</li>
          </ul>
          <ul class="list-inline">
            <li class="list-inline-item" v-if="customer_data.phone">
              <a :href="'tel:' + customer_data.phone" title="Call" class="btn btn-primary"><i class="bi bi-telephone"></i></a>
            </li>
            <li class="list-inline-item" v-if="customer_data.phone">
              <button v-b-modal="'textmessage-modal'" title="SMS" class="btn btn-primary"><i class="bi bi-chat"></i></button>
            </li>
            <li class="list-inline-item" v-if="customer_data.email">
              <a :href="'mailto:' + customer_data.email" title="Email" class="btn btn-primary"><i class="bi bi-envelope"></i></a>
            </li>
            <li class="list-inline-item">
              <button @click="EditCustomerModal" title="Edit" class="btn btn-primary"><i class="bi bi-pencil-square"></i></button>
            </li>
            <li class="list-inline-item" v-if="userDetails.roles[0].name === 'Admin' || hasPermission('can manage customers')">
              <button @click="DeleteCustomer(customer_data.id)" title="Delete" class="btn btn-danger"><i class="bi bi-trash"></i></button>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Right Column -->
    <div class="col-md-8 col-sm-12">
      <div class="row text-center mb-3">
        <div class="col-sm-4 border">
          <p class="font-weight-bold text-dark py-1">{{ customer_orders.length }}</p>
          <small>Visits</small>
        </div>
        <div class="col-sm-4 border">
          <p class="font-weight-bold text-dark py-1">{{ max_order }}</p>
          <small>Highest Order Amount</small>
        </div>
        <div class="col-sm-4 border">
          <p class="font-weight-bold text-dark py-1">{{ last_visit }}</p>
          <small>Last Visit</small>
        </div>
      </div>

      <!-- Orders Table -->
      <div v-if="orderstable.items.length > 0">

        <div class="d-flex justify-content-between align-items-center">
          <h4>Recent Transactions</h4>
          <a @click="downloadCustomerReport(customer_data.id)" class="btn btn-outline-secondary">Download <i class="bi bi-download"></i></a>
        </div>
        <b-table
          sticky-header="100vh"
          hover
          :items="orderstable.items"
          :fields="orderstable.fields"
          sort-icon-left
          responsive="sm"
          @row-clicked="customerTrxRowSelected"
        >
          <template #cell(index)="data">
            <span>{{ data.index + 1 }}</span>
          </template>
        </b-table>
         <!-- <b-pagination
                v-model="currentPage"
                :total-rows="totalCustomers"
                :per-page="perPage"
                @input="getCustomer">
            </b-pagination> -->
      </div>
      <div v-if="product_insights">
  <h4>Product Insights</h4>
        <div class="d-flex justify-content-between align-items-center">
            <div class="table-responsive">
   <table class="table ">
            <thead>
                <tr>
                    <td>#</td>
                    <td>Item</td>
                    <td>Qty</td>
                    <td>Total Spent</td>
                    <td>Purchase Count</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="insight in product_insights">
                    <td>#</td>
                    <td>{{ insight.product_name }}</td>
                    <td> {{ insight.total_qty }} </td>
                    <td> {{ insight.total_spent }} </td>
                    <td> {{ insight.purchase_count }} </td>
                    <td> {{ formatDate(insight.last_purchased_at,'h:mm A DD-MM-yyyy') }} </td>

                </tr>
            </tbody>
          </table>
            </div>
            <hr />
            <div class="mb-5"></div>

        </div>

      </div>

      <!-- No Orders -->
      <div v-else class="d-flex justify-content-center align-items-center" style="height: 300px;">
        <div class="text-center">
          <img src="/images/embarrassed.png" style="width:100px;" class="img-fluid">
          <h6 class="py-3">Customer hasn't made any order</h6>
        </div>
      </div>
    </div>
  </div>
    <b-modal ref="edit-customer-modal" hide-footer static>

            <div class="container text-center">
                <div class="text-centre"><h2 class="font-weight-bold ">Update {{customer_data.full_name}}'s info</h2></div>

            </div>
            <div class="text-center" v-html="successMessage">{{successMessage}}</div>
            <div class="container py-3">
                <!-- Actual search box -->
                <form v-on:submit="EditCustomerInfo">
                    <div class="form-row py-1">
                        <div class="col-12">
                            <input class="form-control border-bottom" v-model="customer_data.full_name" name="f_name" type="text" placeholder="First Name"/>


                        </div>

                    </div>
                    <div class="form-group py-1">

                        <input class="form-control border-bottom" name="c_email" v-model="customer_data.email" type="email" placeholder="Email"/>


                    </div>
                    <div class="form-group">

                        <input class="form-control border-bottom" v-model="customer_data.phone" name="phone_no" type="text" placeholder="Phone Number"/>


                    </div>
                    <div class="form-row py-1">
                        <div class="col-6">
                            <input class="form-control border-bottom" v-model="customer_data.address_address" name="h_no" type="text" placeholder="House Number"/>
                        </div>
                        <div class="col-6">
                            <input class="form-control border-bottom" v-model="customer_data.apartment" name="apartment" type="text" placeholder="Apartment"/>
                        </div>
                    </div>

                    <div class="form-group pt-3">
                        <button class="btn btn-primary btn-block">Update</button>
                    </div>
                </form>
            </div>



        </b-modal>
  </div>


</template>

<script>
import moment from 'moment';
import { mapGetters } from "vuex";
export default {
  name: 'customer-profile',

  data() {
    return {
      customer_data: {},
      product_insights:[],
      customer_orders: [],

    successMessage: '',
      max_order: 0,
      last_visit: '',
      orderstable: {
        fields: [
          "index",
          { key: "order", sortable: true },
          { key: "amount", sortable: true },
          { key: "date_", sortable: true },
        ],
        items: []
      },
    };
  },
   computed: {

         ...mapGetters(['userDetails']),
   },
  mounted() {
    this.getcustomer_data();
  },

  methods: {
    getCustomerIdFromURL() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('id');
    },
 customerTrxRowSelected(item) {
                window.location.replace('/orders?order-number=' + item.orderId + '&source=/customers?cid=')
            },
    async getcustomer_data() {
      const customerId = this.getCustomerIdFromURL();

      try {
        const response = await axios.get('/api/customer_details', {
          params: { customer_id: customerId }
        });

        const result = response.data;
        this.customer_data = result.customer;
        this.max_order = result.max_order;
        this.customer_orders = result.final_order;
        this.product_insights = result.product_insights	;

        this.orderstable.items = result.final_order.map(order => ({
          order: order.order,
          orderId: order.id,
          amount: order.total_amount,
          date_: moment(order.created_at).format("DD-MM-YYYY hh:mm A")
        }));

        if (result.final_order.length > 0) {
          this.last_visit = moment(result.final_order[0].created_at).fromNow();
        }
      } catch (error) {
        console.error('Error loading customer insights:', error);
      }
    },

    async downloadCustomerReport(customer_id) {
      try {
        const response = await axios.get('/api/customer-transaction-reports', {
          params: { customer_id },
          responseType: 'blob'
        });

        if (response.status === 200) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          const fileName = `Report-${moment().format('YYYY-MM-DD-HH-mm')}.pdf`;
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
        } else {
          alert('Error downloading report');
        }
      } catch (error) {
        console.error(error);
      }
    },

            EditCustomerInfo(e) {
                e.preventDefault();
                axios.post('/api/updatecustomer', {
                        ...this.customer_data
                    })
                    .then(result => {
                        if (result.status === 200) {
                            this.$root.$toasts.push({
                                type: 'success',
                                message: "Customer data updated successfully",
                            });
                            this.$refs['edit-customer-modal'].hide();
                            this.getCustomers()
                        } else {
                            this.$root.$toasts.push({
                                type: 'error',
                                message: "There was an error adding customer",
                            });
                        }
                    });
            },

            hasPermission(permissionName) {
                 return this.userDetails.permissions.some(permission => permission.name === permissionName);
            },
    formatDate(date, format) {
      return moment(date).format(format);
    },
            EditCustomerModal() {
                this.$refs['edit-customer-modal'].show();
                this.$refs['customer_profile'].hide();
            },
  }
};
</script>
